
console.log('Theme NAV geladen');

( function( $ ) {

   $( function () {
      contactbox();
      mobile_nav();
   });

   function mobile_nav() {
      $('#nav_toggle').on('click', function (event) {
         $('body').toggleClass('mainnav_open');
         $('body').removeClass('contactbox_open');
      });


      $('#content, #footer').on('click', function (event) {
         $('body').removeClass('mainnav_open');
      });


      $(window).on("resize", function () {
         if( $('body').hasClass('mainnav_open')  && !$('#nav_toggle').is(':visible')) {
            $('body').removeClass('mainnav_open');
         }
      });


      $('#main-nav li a').on('click', function () {
         const href = $(this).attr('href');

         //if (href.startsWith('#')) {
               $('body').removeClass('mainnav_open');
         //}
      });


   }

   function contactbox() {
      $('#contact_cta').on('click', function (event) {
         $('body').toggleClass('contactbox_open');
         $('body').removeClass('mainnav_open');
      });

      $('#contactbox_close').on('click', function (event) {
         $('body').removeClass('contactbox_open');
      });

      $('#content, #footer').on('click', function (event) {
         $('body').removeClass('contactbox_open');
      });


      $(window).on("resize", function () {
         if( $('body').hasClass('contactbox_open')  && !$('#nav_toggle').is(':visible')) {
            $('body').removeClass('contactbox_open');
         }
      });
   }



} )( jQuery );
